// removed by extract-text-webpack-plugin
module.exports = {"component":"sb4O03wfWsYb2exo9u5-i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ThankYouPage/CardWidgetPage/cardWidget.css
// module id = 1276
// module chunks = 2